import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Session, User } from '@supabase/supabase-js'
import type { Tables } from '@/types/supabase'

type Tenant = Tables<'tenants'>

interface AuthState {
  session: Session | null
  user: User | null
  currentTenant: Tenant | null
  /** True once the initial session check from Supabase storage has completed. */
  initialized: boolean
  setSession: (session: Session | null) => void
  setCurrentTenant: (tenant: Tenant | null) => void
  setInitialized: (initialized: boolean) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      user: null,
      currentTenant: null,
      initialized: false,
      setSession: (session) =>
        set({ session, user: session?.user ?? null }),
      setCurrentTenant: (currentTenant) => set({ currentTenant }),
      setInitialized: (initialized) => set({ initialized }),
      clear: () => set({ session: null, user: null, currentTenant: null }),
    }),
    {
      name: 'oneidol-auth',
      // Only persist the tenant cache — session is owned by Supabase SDK's own localStorage key
      partialize: (state) => ({
        currentTenant: state.currentTenant,
      }),
    }
  )
)
